import React from "react";
import { ExternalLink } from "lucide-react";
import { SEO } from "../components/SEO";

const StorePage = () => {
  return (
    <div className="pt-20" data-testid="store-page">
      <SEO
        title="Service Store"
        description="Browse and purchase FunAsia Digital services securely. AI Receptionist, SEO, Reputation, Local Listings, and more."
        path="/store"
      />
      <section className="section-padding bg-gradient-to-br from-orange-light via-white to-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8">
            <h1 className="font-display text-4xl md:text-5xl font-bold text-gray-dark mb-4">Service Store</h1>
            <p className="text-gray-medium max-w-2xl mx-auto mb-2">Browse and purchase our digital marketing services</p>
            <p className="text-sm text-gray-medium">All purchases and subscriptions are securely processed in our store.</p>
          </div>

          <div className="store-iframe-container mb-6">
            <iframe
              id="storePreview"
              src="https://login.funasiadigital.com/public/store/FUNA/default/?hide=topbar"
              width="1200"
              height="680"
              title="FunAsia Digital Store"
              data-testid="store-iframe"
            />
          </div>

          <div className="text-center">
            <a
              href="https://login.funasiadigital.com/public/store/FUNA/default/?hide=signin"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-secondary inline-flex items-center gap-2"
              data-testid="store-external-link"
            >
              Open Store in New Tab <ExternalLink size={18} />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default StorePage;
